import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Types from '../../modules/types';

import getRoleBasedPath from '../../helpers/getRoleBasedPath';
// eslint-disable-next-line max-len
import { DateLink, getLinkWithSearchFields, getSubjectUrl, StoreLink } from '../../components/Links';
// eslint-disable-next-line max-len
import { columnCreatedAt, columnUpdatedAt } from '../../components/common';
import Popover from '../../components/Popover';
// eslint-disable-next-line max-len
export const columnStoreId = { path: 'storeId', title: 'Store ID', link: '/stores/:store._id' };
// eslint-disable-next-line max-len
export const orderLength = { path: 'store.orders', title: 'Orders', sort: 'orders' };
export const columnTotal = { path: 'total', title: 'Total', sort: 'total' };
export const columnPayouts = { path: 'payouts.length', title: 'Stores' };
export const soa = { title: 'SOA' };
// export const blanace = { path: 'balance', title: 'Blanace', sort: 'balance' };
// export const blanace = { path: 'balance', title: 'Blanace', sort: 'balance' };
// export const blanace = { path: 'balance', title: 'Blanace', sort: 'balance' };

export const columnActive = {
  path: 'active',
  title: 'Status',
  render: record => (record.active ? 'ACTIVE' : 'INACTIVE'),
};

function StoreLinkForPayouts({
  location,
  subject,
  filterName = 'store',
  searchLabel = 'store',
  children,
  style,
}) {
  if (!subject) {
    return 'N / A';
  }
  return (
    <Popover
      title={null}
      content={(
        <div>
          <span>Show orders with </span>
          <Link
            to={getLinkWithSearchFields(
              location,
              [{ name: filterName, value: subject._id }],
              { pathname: '/payout/merchant' },
            )}
          >
            {`this ${searchLabel}`}
          </Link>
        </div>
      )}
    >
      <Link style={style} to={getSubjectUrl('/stores', subject)}>
        {
          children
            ? children
            : `${subject.name}`
        }
      </Link>
    </Popover>
  );
}

export const columnCyclePeriod = {
  title: 'Cycle Period',
  render: (record, column, props) => {
    const formattedStartDate = moment(record.startDate).format('MMMM Do');
    const formattedEndDate = moment(record.endDate).format('MMMM Do');
    return (
      <Link to={`/cycles/${record._id}`}>
        <div>
          {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
          {`From ${formattedStartDate} to ${formattedEndDate}`}
        </div>
      </Link>

    );
  },
};

export const columnStartedAt = {
  path: 'startDate',
  title: 'Started Date',
  sort: 'startDate',
  render: (record, column, props) => (
    <div>
      {moment(record.createdAt).format(
        'dddd, MMMM Do YYYY [at] h:mm a'
      )}
    </div>
  ),
};

export const columnOrders = {
  path: 'payouts',
  title: 'Total Orders',
  render: (record, column, props) => {
    let totalOrders = 0;
    record.payouts.forEach(payout => {
      if (payout.store && payout.store.orders) {
        totalOrders += payout.store.orders;
      }
    });
    return (
      <div>
        {totalOrders}
      </div>
    );
  },
};

export const columnEndedAt = {
  path: 'endDate',
  title: 'End Date',
  sort: 'endDate',
  render: (record, column, props) => (
    <div>
      {moment(record.createdAt).format(
        'dddd, MMMM Do YYYY [at] h:mm a'
      )}
    </div>
  ),
};

export const columnStore = {
  path: 'store',
  title: 'Store Name',
  render: (record, column, props) => (
    record.store
      ? (
        // <StoreLinkForPayouts
        //   location={props.location}
        //   subject={record.store}
        //   pathname={getRoleBasedPath(props, '/orders')}
        // />
        record.store.name
      )
      : 'N/A'
  ),
};

export const ADMIN = [
  columnCyclePeriod,
  columnTotal,
  columnPayouts,
  columnOrders,
  // columnStartedAt,
  // columnEndedAt,
  // columnStoreId,
  // columnStore,
  // orderLength,
  // blanace,
  // soa,
  columnCreatedAt,
  columnUpdatedAt,
];

export const SELLER = [
  // columnStoreId,
  // columnStore,
  // orderLength,
  // blanace,
  // columnCreatedAt,
  // columnUpdatedAt,
];
